import { useEffect, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import {
  resetPassword,
  RootState,
  sendOTP,
  sendOtpToUsername,
  showToast,
  useAppDispatch,
  useAppSelector,
} from "@hypexone/uicore";
import { connect } from "react-redux";
import { SIGN_UP_ROUTE } from "@hypexone/uicore";
import Button from "../../components/shared/Button/Button";
import { isWhatsappSignup } from "../../../constants/Branding";

const ForgotPassword = (props) => {
  const { otpSuccess, showToast } = props;
  const [method, setMethod] = useState("Username");
  const [username, setUsername] = useState("");
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [countryCode, setCountryCode] = useState("+91");
  const navigate = useNavigate();
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [otpTimer, setOtpTimer] = useState<number>();
  const { otpSent } = useAppSelector((state) => state.auth);
  // console.log('otp sent--->',otpSent);
  const {langData} = useAppSelector((state) => state.cms);
  const { domainConfig } = useAppSelector((state) => state.common);
  // HA signup off + signin on => Sign Up opens the registration WhatsApp link instead of the sign-up page.
  const registrationWhatsappLink = domainConfig?.suppportContacts?.find(
    (ct) => ct.contactType === "REGISTRATION_WHATSAPP_LINK"
  )?.details;
  const whatsappSignup = isWhatsappSignup(domainConfig);
  const showSignUp = whatsappSignup
    ? !!registrationWhatsappLink
    : domainConfig?.signup && domainConfig?.b2cEnabled;
  const handleOtpTimer = (time) => {
    if (time >= 0) {
      setOtpTimer(time);
      setTimeout(() => {
        handleOtpTimer(time - 1);
      }, 1000);
    } else {
      setTimeout(() => {
        setOtpTimer(undefined);
      }, 1000);
    }
  };
  useEffect(()=>{
    if(otpSuccess){
      handleOtpTimer(60);
    }
  },[otpSuccess])
  
  useEffect(()=>{
    if(otpSent){
      handleOtpTimer(60);
    }
  },[otpSent])

  const dispatch = useAppDispatch();

  const showConfirmPasswordClickHandler = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const showPasswordClickHandler = () => {
    setShowPassword(!showPassword);
  };

  const handleMethodChange = (newMethod) => {
    setMethod(newMethod);
    setUsername("");
    setMobile("");
  };

  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  };

  const handleMobileChange = (event) => {
    setMobile(event.target.value);
  };

  const handleCountryCodeChange = (event) => {
    setCountryCode(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    dispatch(
      sendOtpToUsername({
        username: username,
        phonenumber: countryCode.slice(1, countryCode.length) + mobile,
        option: method,
      })
    );
  };

  const redirectToSignUp = () => {
    if (whatsappSignup) {
      window.open(registrationWhatsappLink, "_blank");
      return;
    }
    navigate(SIGN_UP_ROUTE);
  };

  const handleResetPassword = () => {
    if (newPassword !== confirmPassword) {
      showToast({
        message: "Passwords didn't match",
        type: "error",
      });
      return;
    } else {
      dispatch(resetPassword({
        username: username,
        phoneNumber: '91' + mobile,
        resetPassword: newPassword,
        otp: otp,
        option: method,
      }));
    }
  };


  const handleBackPress = () => {
    navigate(-1);
  };

  return (
    <div className={`flex items-center h-screen justify-center w-screen bg-gradient-to-r from-blue2 via-blue1 to-blue3`}>
      <div className="flex items-center justify-center w-full">
        <div className=" rounded w-full max-w-sm">
          <Button
            onClick={handleBackPress}
            className="flex items-center gap-1.5 text-sm font-medium whitespace-nowrap text-stone-900 w-[61px]
             absolute top-4 left-4 sm:relative sm:top-0 sm:left-0"
          >
            <FaArrowLeftLong className="text-white" />
            <span className="my-auto text-white">{langData?.['back']}</span>
          </Button>
          <h2 className="text-2xl text-center font-bold mb-4 text-white">
          {langData?.['forgot_password']}
          </h2>
          {!otpSuccess ? (
            <>
              <p className="mb-6 text-white">
              {langData?.['otp_send_msg']}
              </p>
              <div className="mb-4 flex">
                <Button
                  className={`flex-1 py-2 ${method === "Username"
                      ? "bg-black1 text-blue32"
                      : "bg-gray-200"
                    }`}
                  onClick={() => handleMethodChange("Username")}
                >
                  {langData?.['username']}
                </Button>
                <Button
                  className={`flex-1 py-2 ${method === "mobile"
                      ? "bg-black1 text-blue32"
                      : "bg-gray-200"
                    }`}
                  onClick={() => handleMethodChange("mobile")}
                >
                  Mobile Number
                </Button>
              </div>
              <form onSubmit={(e) => handleSubmit(e)}>
                {method === "Username" ? (
                  <div className="mb-4">
                    <label className="block text-white">{langData?.['username']}</label>
                    <input
                      type="text"
                      className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      value={username}
                      onChange={(e) => handleUsernameChange(e)}
                      placeholder={langData?.['enter_username_txt']}
                    />
                  </div>
                ) : (
                  <div className="mb-4">
                    <label className="block text-gray-700">{langData?.['mobile_number']}</label>
                    <div className="flex">
                      <select
                        className="mt-1 block w-20 px-3 py-2 bg-white border border-gray-300 rounded-l-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        value={countryCode}
                        onChange={(e) => handleCountryCodeChange(e)}
                      >
                        <option value="+91">+91</option>
                        {/* Add more country codes as needed */}
                      </select>
                      <input
                        type="text"
                        className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-r-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        value={mobile}
                        onChange={(e) => handleMobileChange(e)}
                        placeholder={langData?.['enter_mobile_no']}
                      />
                    </div>
                  </div>
                )}
                <Button
                  type="submit"
                  className="w-full bg-black1 text-blue32 py-2 rounded-md hover:bg-black focus:outline-none focus:text-white"
                >
                  {langData?.['send_otp']}
                </Button>
              </form>
            </>
          ) : (
            <>
              <div className="mb-4">
                <label className="block text-gray-700">{langData?.['otp']}</label>
                <input
                  type="number"
                  className="appearance-none mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-700 focus:border-blue-800 sm:text-sm"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  placeholder={langData?.['enter_otp_txt']}
                />
              </div>
              <div className="mt-5">
                <label
                  htmlFor="password"
                  className="self-start text-neutral-500"
                >
                  {langData?.['password']}
                </label>
                <div className="flex gap-5 justify-between px-3.5 py-3 mt-3 bg-white rounded-lg border border-solid border-neutral-200 placeholder:text-neutral-500 text-opacity-60">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    className="w-full bg-transparent border-none focus:outline-none"
                    placeholder={langData?.['enter_your_password']}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                  <div
                    className="cursor-pointer text-neutral-500"
                    onClick={() => showPasswordClickHandler()}
                  >
                    {showPassword ? <FaEye /> : <FaEyeSlash />}
                  </div>
                </div>
              </div>
              <div className="mt-5 mb-5">
                <label
                  htmlFor="password"
                  className="self-start text-neutral-500"
                >
                  {langData?.['confirm_password']}
                </label>
                <div className="flex gap-5 justify-between px-3.5 py-3 mt-3 bg-white rounded-lg border border-solid border-neutral-200 placeholder:text-neutral-500 text-opacity-60">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    id="password"
                    className="w-full bg-transparent border-none focus:outline-none"
                    placeholder={langData?.['confirm_your_password']}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                  <div
                    className="cursor-pointer text-neutral-500"
                    onClick={() => showConfirmPasswordClickHandler()}
                  >
                    {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
                  </div>
                </div>
              </div>
              <Button
                className={`w-full my-1 bg-blue-800 text-white py-2 rounded-md hover:bg-blue-700 focus:outline-none focus:bg-blue-800 ${otpTimer !== undefined && otpTimer !== null && otpTimer >= 0
                    ? 'bg-neutral-400 text-white cursor-not-allowed'
                    : 'bg-blue-500 hover:bg-blue-600 text-white cursor-pointer'
                  }`}
                disabled={otpTimer !== undefined && otpTimer !== null && otpTimer >= 0}
                onClick={() => {
                  if (!otpTimer) {
                    dispatch(sendOTP('91' + mobile));
                    handleOtpTimer(60);
                  }
                }}
              >
                {otpTimer !== undefined && otpTimer !== null && otpTimer >= 0
                  ? `Resend in ${otpTimer} sec`
                  : 'Send OTP'}
              </Button>
              <Button
                className="w-full bg-blue-800 text-white py-2 rounded-md hover:bg-blue-700 focus:outline-none focus:bg-blue-800"
                onClick={handleResetPassword}
              >
                {langData?.['reset_password_txt']}
              </Button>
            </>
          )}
          {showSignUp && (
          <p className="self-center mt-4 text-sm text-center text-white">
          {langData?.['account_not_found_txt']}{" "}
            <a
              href="#"
              className="font-semibold text-yellow-400 underline"
              onClick={() => redirectToSignUp()}
            >
              {whatsappSignup
                ? langData?.['sign_in'] || 'Sign In'
                : langData?.['sign_up']}
            </a>
          </p>
          )}
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state: RootState) => {
  return {
    otpSuccess: state.auth.otpSuccess,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    showToast: (event: any) => dispatch(showToast(event)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
